'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { apiGtm } from '../lib/apiGtm';
import { GTMEcommerceItem } from '../lib/types';
import { shouldSendGtmPageView } from '../utils/gtmNavigationHistory';

interface GTMPageViewProps {
  event: 'view_item' | 'view_cart' | 'begin_checkout';
  value?: number;
  coupon?: string;
  items: GTMEcommerceItem[];
}

export function GTMPageView({ event, value, coupon, items }: GTMPageViewProps) {
  const pathname = usePathname();

  useEffect(() => {
    if (!shouldSendGtmPageView(pathname, event)) return;

    const t = setTimeout(() => {
      apiGtm.ecommerce({
        event,
        ecommerce: {
          value,
          coupon,
          items
        }
      });
    }, 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
